<form [formGroup]="note48Form">
  <div class="notes-wrapper">
    <div class="notes-section">
      <ejs-richtexteditor
        [toolbarSettings]=" commonService.syncfusionRichTextEditorToolbarSettings"
        (actionBegin)="commonService.syncfusionRichTextEditorOnActionBegin($event)"
        [enableXhtml]="true"
        [toolbarSettings]="commonService.syncfusionRichTextEditorTools"
        formControlName="textbox1"
        [enableHtmlSanitizer]="true"
        [pasteCleanupSettings]="commonService.syncfusionRichTextEditorPasteCleanupSettings"
      ></ejs-richtexteditor>
    </div>
  </div>
</form>
